"use client";

import { LockOpen } from "lucide-react";

export function SampleLink({ href }: { href: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-md bg-cb-success/10 text-cb-success border border-cb-success/20 font-medium hover:bg-cb-success/20 transition-colors"
    >
      <LockOpen className="h-3 w-3" />
      Sample
    </a>
  );
}
